import React, { useEffect, useState } from 'react';
import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';
import toast from 'react-hot-toast';
import { useQuery } from 'jsonapi-react';
import { useSession } from '@/hooks/useSession';
import { TableUsers } from './table-users';

export function WeekChallengeRankingByParticipant() {
  const [users, setUsers] = useState([]);
  const { data, error, isLoading } = useQuery('/challenges/ranking?users=true');
  const { session } = useSession();

  useEffect(() => {
    if (data) setUsers(data.data);
  }, [data]);

  useEffect(() => {
    if (error) {
      toast.error('Erro ao buscar os participantes');
    }
  }, [error]);

  if (isLoading) return <Loader />;

  if (users?.length === 0)
    return (
      <EmptyState
        type="data"
        text="Nenhum participante encontrado"
      />
    );

  return (
    <TableUsers
      users={users}
      session={session}
    />
  );
}
